const reportsActions = {
  SET_REPORTS_INIT_STATE: 'SET_REPORTS_INIT_STATE',
  GET_REPORTS: 'GET_REPORTS'
};
export default reportsActions;
